export const COLOR_CHECKBOX_CUSTOM = '#FEA628';
export const COLOR_CHECKBOX_NOT_ACTIVE = '#e7e7e7';
